module.exports = __webpack_public_path__ + "static/img/guard.9454370e.svg";